// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2wEJg","inputWrap":"Table_inputWrap__1aMcU","col":"Table_col__VgAiV","bmiTooltip":"Table_bmiTooltip__pOtNu"};